import { stripUnit } from 'polished';

export function getNegativeCssValue(value: string) {
    if (!stripUnit(value, true)[1]) return value;
    return `-${value}`;
}
